import React from 'react';
import Duration from './Duration'
import { 
	PauseIcon, 
	PlayIcon,
	ChevronLeftIcon,  // Add these new imports
	ChevronRightIcon,
	ChevronDoubleLeftIcon,
	ChevronDoubleRightIcon 
  } from '@heroicons/react/20/solid';

export default function ControlArea(props) {
	return (

		<div className="belowArea" style={{marginTop: '15px'}}>
			<div className="begin"><Duration seconds={props.duration * props.played} /></div>
			<div className="controllers active">

        <ChevronDoubleLeftIcon style={{width:'1.5rem'}} onClick={props.rewind} />

        <ChevronLeftIcon style={{width:'1.5rem'}} onClick={props.playPreviousEpisode} />
				
				{ props.playing ? <PauseIcon style={{width:'1.5rem'}} onClick={props.handlePause} /> : <PlayIcon style={{width:'1.5rem'}} onClick={props.handlePlay} /> }
				
				<ChevronRightIcon style={{width:'1.5rem'}} onClick={props.playNextEpisode} />

				<ChevronDoubleRightIcon style={{width:'1.5rem'}} onClick={props.fastForward} />

			</div>
			<div className="end"><Duration seconds={props.duration} /></div>
		</div>

	);
}